import styled from 'styled-components';

interface TextButtonProps {
	title: string;
	onClick: () => void;
	disabled?: boolean;
	style?: any;
}

const StyledTextButton = styled.button`
	color: var(--color-font-grey);
	font-size: 14px;
	font-weight: 600;
	line-height: 18.2px;
	letter-spacing: -0.28px;
	text-decoration-line: underline;
	cursor: pointer;
	background: none;
	border: none;
	padding: 0;
`;

const CustomTextButton: React.FC<TextButtonProps> = ({
	style = {},
	title,
	onClick,
	disabled = false,
}) => {
	return (
		<StyledTextButton style={style} onClick={onClick} disabled={disabled}>
			{title}
		</StyledTextButton>
	);
};

export default CustomTextButton;
